import { render, staticRenderFns } from "./BroadBandDate.vue?vue&type=template&id=618f347b&scoped=true"
import script from "./BroadBandDate.vue?vue&type=script&lang=js"
export * from "./BroadBandDate.vue?vue&type=script&lang=js"
import style0 from "./BroadBandDate.vue?vue&type=style&index=0&id=618f347b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618f347b",
  null
  
)

export default component.exports